var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Footer',{attrs:{"columns":_vm.columns}},[_c('FooterOfficeInformation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }